import React from "react";
import { Spin } from "antd";
import { TaxSettings } from "@design-system";
import { useOfficeLocationsQuery } from "~/graphql/query";
import { useSettings } from "~/hooks";
import { useMutation } from "@apollo/client";
import { UPDATE_OFFICE_LOCATIONS } from "~/graphql/mutation";

export const TaxSettingsContainer = () => {
  const { data, loading: loadingOfficeLocations } = useOfficeLocationsQuery();
  const { settings, loading: loadingSettings } = useSettings();
  const { taxLabel: defaultTaxLabel, taxLevelPercent: defaultTaxLevelPercent } = settings || {};
  const [updateOfficeLocationsMutation] = useMutation(UPDATE_OFFICE_LOCATIONS);

  return loadingOfficeLocations ||
    loadingSettings ||
    defaultTaxLabel === undefined ||
    defaultTaxLevelPercent === undefined ? (
    <Spin size="large" />
  ) : (
    <TaxSettings
      officeLocations={data?.officeLocations || []}
      defaultTaxLabel={defaultTaxLabel}
      defaultTaxLevelPercent={defaultTaxLevelPercent}
      handleTaxLabelChange={async (countryCode, value) => {
        await updateOfficeLocationsMutation({
          variables: {
            input: {
              countryCode: countryCode,
              taxLabel: value,
            },
          },
        });
      }}
      handleTaxLevelChange={async (countryCode, value) => {
        await updateOfficeLocationsMutation({
          variables: {
            input: {
              countryCode: countryCode,
              taxLevelPercent: value,
            },
          },
        });
      }}
      handleResetToDefault={async (countryCode) => {
        await updateOfficeLocationsMutation({
          variables: {
            input: {
              countryCode: countryCode,
              taxLabel: defaultTaxLabel,
              taxLevelPercent: defaultTaxLevelPercent,
            },
          },
        });
      }}
    />
  );
};
